import * as React from 'react';
import {connect} from 'react-redux';
import {IUserFavoritesProps} from "./IUserFavoritesProps";
import {IUserFavoritesState} from "./IUserFavoritesState";
import PostComponent from "../../components/PostComponent/PostComponent";
import PostsComponent from "../../components/PostsComponent/PostsComponent";

import HeaderComponent from "../../components/homeHeader";
import MenuComponent from "../../components/menuComponent/MenuComponent";
import {ToastContainer} from "react-toastify";

import FooterComponent from "../../components/footerComponent/FooterComponent";
import MasonryComponent from "../../components/masonryComponent/MasonryComponent";
import fb from "../../assets/images/_fb.png";
import tw from "../../assets/images/_tw.png";
import ins from "../../assets/images/_ins.png";
import MenuLeftemobile from "../../components/menuLeftMobile/MenuLeftemobile";



class UserFavorites extends React.Component<IUserFavoritesProps, IUserFavoritesState> {

    constructor(props : IUserFavoritesProps) {
        super(props);

    }


    render() {
        console.log(this.props.user)
        return (
            <div>
                <MenuLeftemobile/>
                <HeaderComponent />
                <MenuComponent/>
                <ToastContainer />


                <div className="_difContent">
                    <div className="container extraContainerHeight">
                        {    <div className="_nextprevRow">
                        </div>}
                        <div className="content">
                            <div className="row">
                                <div className="col _info">
                                    <div className="_img">
                                        {this.props.user && this.props.user.photo ?
                                            (this.props.user.photo.includes('graph.facebook.com') ?
                                                    <img src={this.props.user.photo + '?width=500'} alt="gif title "/>
                                                    :<img src={this.props.user.photo} alt="gif title "/>
                                            )
                                            :null}
                                    </div>
                                    <div className="name">
                                        { this.props.user && this.props.user.name ?
                                            this.props.user.name
                                            : null}
                                    </div>
                                    {/*<div className="description">
                                    {this.props.user.displayName}</div>*/}
                                    <div className="follow">
                                        <div className="title">
                                            suivre sur
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <a className="facebook" href="#"> <img src={fb}/></a>
                                            </div>
                                            <div className="col">
                                                <a className="twitter" href="#"> <img src={tw} /></a>
                                            </div>
                                            <div className="col">
                                                <a className="instagram" href="#"> <img src={ins}/></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col _content" style={{
                                    maxWidth : '696px'
                                }}>

                                    <MasonryComponent title={'Mes Favoris'} size={6} url={'https://europe-west1-ttgif-3c665.cloudfunctions.net/userfavs?id=' + this.props.user.uid} uid  />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterComponent/>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return { errorMessage: state.auth.errorMessage ,
        authenticated: state.auth.authenticated ,
        user: state.auth.currentUser
    };
}
export default connect(
    mapStateToProps,null
)(UserFavorites);



// WEBPACK FOOTER //
// ./src/containers/userFavorites/UserFavorites.tsx